import {ListCarousel, reviewCarousel} from "./ListCarousel";

export const wbsCarousels = () => {


    ListCarousel('.categories-list', {
        perPage: 1.5,
        arrows: true,
        mediaQuery: 'min',
        padding: {left: '1rem', right: '2rem'},
        trimSpace: true,
        focus: 'center',
        gap: 15,
        breakpoints: {
            800: {
                destroy: true
            }
        }
    });


    ListCarousel('.recent-posts-list', {
        perPage: 1.2, arrows: true, mediaQuery: 'min', trimSpace: true, focus: 'center', gap: 15, breakpoints: {
            800: {
                destroy: true
            },
        }
    });


    ListCarousel('.series-gallery', {
        perPage: 1.5,
        padding: {left: 'calc(50vw - 42.5rem)', right: '2rem'},
        trimSpace: true,
        type: 'loop',
        focus: 'center',
        autoplay: true,
        gap: '1rem',
        breakpoints: {
            1024: {
                perPage: 3.5, // trimSpace: false
            },
        }
    });

    ListCarousel('.testimonials', {
        perPage: 1.5,
        arrows: true,
        mediaQuery: 'min',
        padding: {left: '1rem', right: '2rem'},
        gap: '1rem',
        focus: 'center',
        rewind: true,
        rewindByDrag: true,
        breakpoints: {
            1024: {
                perPage: 3, gap: '1.97rem',
            },
        }
    }, {
        sizerClass: '.testimonials-section .container', sizerBreakpoint: 1024,
    });


    ListCarousel('.featured-reviews ', {
        perPage: 1,
        arrows: false,
        mediaQuery: 'min',
        padding: {left: '1rem', right: '2rem'},
        gap: '1rem',
        focus: 'center',
        rewind: true,
        rewindByDrag: true,
        breakpoints: {
            768: {
                perPage: 2, gap: '1.97rem',
            }, 1024: {
                perPage: 4,

            }, 1800: {
                perPage: 5,
            },
        }
    }, {
        sizerClass: '.featured-reviews-section .container',
        sizerBreakpoint: 1024,
        customArrow: true,
        customArrowPrev: '.featured-reviews-section .custom-splide-arrows__prev ',
        customArrowNext: '.featured-reviews-section .custom-splide-arrows__next',
    });


    ListCarousel('.product-patrons', {
        autoplay: true, perPage: 3, mediaQuery: 'min', trimSpace: true,

    });

    reviewCarousel('.product-reviews__items', {
        perPage: 1, breakpoints: {
            768: {
                perPage: 2,
            }, 1024: {
                perPage: 3,
            }, 1300: {
                perPage: 3,
            },
        }

    });


    ListCarousel('.instagramCarousel', {
        perPage: 1.5,
        autoplay: true,
        arrows: false,
        mediaQuery: 'min',
        trimSpace: true,
        focus: 'center',
        gap: '1rem',
        rewind: true,
        rewindByDrag: true,
        fixedWidth: '256px',
        fixedHeight: '256px',
        breakpoints: {
            1024: {
                perPage: 5.5, gap: '1.7rem',
            }, 800: {
                perPage: 4.5, fixedWidth: '384px', fixedHeight: '384px',
            },
        }
    });


    ListCarousel('.messagesCarousel', {
        autoplay: true,
        pagination: true,
        type: 'loop',
        interval: 10000,
        perPage: 1.5,
        focus: 'center',
        mediaQuery: 'min',
        trimSpace: true,
        gap: '1rem',
        breakpoints: {
            800: {
                perPage: 3,

            },
        }
    });


    ListCarousel('.product-bundles', {
        perPage: 1, arrows: true
    });

    ListCarousel('.postsCardWide', {
        perPage: 1.1,
        mediaQuery: 'min',
        padding: {left: '1rem', right: '0.5rem'},
        trimSpace: true,
        focus: 'center',
        gap: 15,
        breakpoints: {
            800: {
                perPage: 2.5, padding: {left: '2.65rem', right: '1rem'},

            },
        }
    });


}